/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

const addFile = (file) => new Promise(async (resolve, reject) => {
    try {
        const userId = localStorage.getItem('userId');
        if (userId) {
            const id = Date.now();
            const db = await connector();
            const transaction = db.transaction('files', 'readwrite');
            const filesStore = transaction.objectStore('files');

            filesStore.add({ userId, id, file });

            transaction.oncomplete = () => {
                db.close();
                resolve({ success: true, id });
            };
        }
        else {
            reject({ success: false, error: 'Error: User not found!' });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getFile = (id) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('files', 'readonly');
        const filesStore = transaction.objectStore('files');

        const file = filesStore.get(id);

        transaction.oncomplete = () => {
            db.close();
            if (file.result && file.result.file) {
                resolve({ success: true, file: file.result.file });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const deleteFile = (id) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('files', 'readwrite');
        const filesStore = transaction.objectStore('files');

        filesStore.delete(id);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const files = {
    addFile,
    getFile,
    deleteFile
}

export default files;
